"use strict";
/**
 * Translate engine.
 */
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitSentence = exports.translate = void 0;
// JS lacks unicode support for word boundary (\b),
// so we have to emulate it
var SPLITTER = /([^\s,.:;?!()"']+)|([\s,.:;?!()"'])+/g;
/**
 * Translate source Cyrillic string into Latin using specified schema.
 * Translates sentences word by word, delegating specifics of transliteration
 * to specified schema.
 */
function translate(source, schema) {
    var translated = splitSentence(source).map(function (word) { return translateWord(word, schema); });
    return translated.join("");
}
exports.translate = translate;
function splitSentence(source) {
    return __spread(source.matchAll(SPLITTER)).map(function (y) { return y[0]; });
}
exports.splitSentence = splitSentence;
function translateWord(word, schema) {
    var _a = __read(splitWord(word), 2), stem = _a[0], ending = _a[1];
    var translatedEnding = ending ? schema.translateEnding(ending) : undefined;
    var translated;
    if (translatedEnding) {
        translated = translateLetters(stem, schema);
        translated.push(translatedEnding);
    }
    else {
        translated = translateLetters(word, schema);
    }
    return translated.join("");
}
function translateLetters(word, schema) {
    var e_1, _a;
    var translated = [];
    try {
        for (var _b = __values(letterReader(word)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 3), prev = _d[0], curr = _d[1], next = _d[2];
            var letter = schema.translateLetter(prev, curr, next);
            translated.push(letter);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return translated;
}
function splitWord(word) {
    var endingLength = 2;
    var stem;
    var ending;
    if (word.length > endingLength) {
        var pivotIdx = word.length - endingLength;
        stem = word.substr(0, pivotIdx);
        ending = word.substr(pivotIdx);
    }
    else {
        stem = word;
        ending = "";
    }
    return [stem, ending];
}
function letterReader(stem) {
    var prev, curr, next, idx;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                prev = "";
                curr = "";
                next = "";
                idx = 0;
                _a.label = 1;
            case 1:
                if (!(idx < stem.length)) return [3 /*break*/, 4];
                if (curr !== "") {
                    prev = curr;
                }
                curr = next || stem[idx];
                if (idx < stem.length - 1) {
                    next = stem[idx + 1];
                }
                else {
                    next = "";
                }
                return [4 /*yield*/, [prev, curr, next]];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                idx++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
